import { componentWithVariants, demoFile, variant } from 'system/demo';
import { ChannelAssignmentDropDown, ChannelSelectionDropDown } from 'open-modules/zdf/component/channels/channel-dropdown';
import { makeAssetUrl } from 'util/util';

const demoChannel0 = {
    channel0: { from: 'a', isDefault: true, key: 'channel0', name: 'Default Channel', photoUrl: makeAssetUrl('/faces/robo.jpeg') },
};
const demoChannel1 = {
    channel1: { from: 'a', isDefault: false, key: 'channel1', name: 'Channel 1', photoUrl: makeAssetUrl('/faces/robo.jpeg') },
};
const demoChannel2 = {
    channel2: { from: 'a', isDefault: false, key: 'channel2', name: 'Channel 2', photoUrl: makeAssetUrl('/faces/face1.jpeg') },
};
const demoChannel3 = {
    channel3: { from: 'a', isDefault: false, key: 'channel3', name: 'Channel 3', photoUrl: makeAssetUrl('/faces/face2.jpeg') },
};
const demoChannel4 = {
    channel4: { from: 'a', isDefault: false, key: 'channel4', name: 'Channel 4', photoUrl: makeAssetUrl('/faces/face3.jpeg') },
};

const channelDemoData1 = {
    modulePublic: {
        channel: {
            all: { ...demoChannel0, ...demoChannel2, ...demoChannel3, ...demoChannel4 },
            instanceToChannel: {},
        },
    },
    serverCall: {
        channel: {
            getUserChannels: async () => [demoChannel2.channel2.key, demoChannel4.channel4.key],
            assignContentToChannel: async () => Promise.resolve(),
            reassignContentToChannel: async () => Promise.resolve(),
        },
    },
};

const channelDemoData2 = {
    modulePublic: { ...channelDemoData1.modulePublic },
    serverCall: {
        channel: {
            getUserChannels: async () => [],
            assignContentToChannel: async () => Promise.resolve(),
            reassignContentToChannel: async () => Promise.resolve(),
        },
    },
};

const channelDemoData3 = {
    modulePublic: {
        channel: {
            all: { ...demoChannel1 },
            instanceToChannel: {
                'question/test': {
                    [demoChannel1.channel1.key]: {
                        channelKey: demoChannel1.channel1.key,
                        from: 'c',
                        instanceKey: 'test',
                        structureKey: 'question',
                        time: 1000,
                    },
                },
            },
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

const channelDemoData4 = {
    modulePublic: {
        channel: {
            all: { ...demoChannel0 },
            instanceToChannel: {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

const channelDemoData5 = {
    modulePublic: {
        channel: {
            all: { ...demoChannel1, ...demoChannel2, ...demoChannel3 },
            instanceToChannel: {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

const channelDemoData6 = {
    modulePublic: {
        channel: {
            all: { ...demoChannel1 },
            instanceToChannel: {},
        },
    },
    serverCall: { ...channelDemoData2.serverCall },
};

const channelDemoData7 = {
    modulePublic: {
        channel: {
            all: { ...channelDemoData1.modulePublic.channel.all },
            instanceToChannel: {
                'question/test': {
                    [demoChannel2.channel2.key]: {
                        concatenatedKey: 'question/test',
                        channelKey: demoChannel2.channel2.key,
                        from: 'c',
                        instanceKey: 'test',
                        structureKey: 'question',
                        time: 1000,
                    },
                },
            },
        },
    },
    serverCall: { ...channelDemoData1.serverCall },
};
import { Narrow } from 'component/basics';

// Use Narrow wrapper for layout similar to legacy demo
function AssignmentDemoWrapper(props) {
    return <Narrow>{props.children}</Narrow>;
}

function AssignmentDemo(props) {
    return <AssignmentDemoWrapper><ChannelAssignmentDropDown {...props} /></AssignmentDemoWrapper>;
}

demoFile('open-modules/zdf/feature/channel-drop-down');

componentWithVariants('ChannelSelectionDropDown', ChannelSelectionDropDown, {}, [
    variant('Multiple channels & default channel available', {
        state: { modulePublic: channelDemoData1.modulePublic, serverCall: channelDemoData1.serverCall, sessionData: { personaKey: 'a' }, roles: ['Moderator'] }
    }),
    variant('Only default channel exists (not visible)', {
        state: { modulePublic: channelDemoData4.modulePublic, serverCall: channelDemoData4.serverCall, sessionData: { personaKey: 'b' }, roles: ['Moderator'] }
    }),
    variant('Multiple regular channels exist but no membership', {
        state: { modulePublic: channelDemoData5.modulePublic, serverCall: channelDemoData5.serverCall, sessionData: { personaKey: 'b' }, roles: ['Moderator'] }
    }),
    variant('Only 1 regular channel exists but no membership (not visible)', {
        state: { modulePublic: channelDemoData6.modulePublic, serverCall: channelDemoData6.serverCall, sessionData: { personaKey: 'b' }, roles: ['Moderator'] }
    })
]);

componentWithVariants('ChannelAssignmentDropDown', AssignmentDemo, {}, [
    variant('No channel assigned, memberships & default channel', {
        state: { modulePublic: channelDemoData1.modulePublic, serverCall: channelDemoData1.serverCall, sessionData: { personaKey: 'a' }, roles: ['Moderator'] }
    }),
    variant('Channel assigned, memberships & default channel', {
        structureKey: 'question',
        instanceKey: 'test',
        state: { modulePublic: channelDemoData7.modulePublic, serverCall: channelDemoData7.serverCall, sessionData: { personaKey: 'a' }, roles: ['Moderator'] }
    }),
    variant('No channel assigned, default channel available', {
        state: { modulePublic: channelDemoData2.modulePublic, serverCall: channelDemoData2.serverCall, sessionData: { personaKey: 'b' }, roles: ['Moderator'] }
    }),
    variant('No channel assigned, no memberships, no default channel', {
        state: { modulePublic: channelDemoData5.modulePublic, serverCall: channelDemoData5.serverCall, sessionData: { personaKey: 'c' }, roles: ['Moderator'] }
    }),
    variant('Channel assigned but not a member of this channel', {
        structureKey: 'question',
        instanceKey: 'test',
        state: { modulePublic: channelDemoData3.modulePublic, serverCall: channelDemoData3.serverCall, sessionData: { personaKey: 'c' }, roles: ['Moderator'] }
    }),
    variant('No channel assigned, no channels exist (not visible)', {
        state: { modulePublic: null, serverCall: channelDemoData2.serverCall, sessionData: { personaKey: 'c' }, roles: ['Moderator'] }
    })
]);
